import { useContext } from "react";
import PropStoreContext from "../../Context/PropStore/PropStoreContext";

function usePropsStore() {
    const [props, setProps] = useContext(PropStoreContext);
    return [props, setProps];
}

export function usePropsStoreValue(key) {
    const [props] = usePropsStore();
    return props[key];
}

export function usePropsStoreSetter(key) {
    const [, setProps] = usePropsStore();
    return (value) => setProps(key, value);
}

export function usePropsStoreState() {
    const [props] = usePropsStore();
    return props;
}

export function usePropsStoreKey(key) {
    const [props, setProps] = usePropsStore();
    return [props[key], (value) => setProps(key, value)];
}

export default usePropsStore;